export default {
  title: 'Консультация',
  phone: 'Номер телефона',
  name: 'Ваше имя',
  email: 'Электронная почта',
  promoCode: 'Промокод',
  question: 'Вопрос или сообщение',
  send: 'Отправить',
  successMessage: 'Спасибо! Скоро перезвоним вам',
  errorMessage: 'Разрешается только одна активная заявка'
}
